import {Component, Output, EventEmitter, Input} from '@angular/core';
import {Dealer} from '@ox/typings';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'webu-preferred-dealer',
  templateUrl: './preferred-dealer-webu.html'
})
export class PreferredDealerWebuComponent {
  @Input() profileAddress: string;
  @Input() preferredDealer: Dealer;
  @Output() showLocateDealer = new EventEmitter();

  public language = window.gm.bml?.lang;
  public displayMode = 'dealerInfo';
  public mapElement: HTMLElement;
  public dealerInfoElement: HTMLElement;

  constructor(
    public modalRef: BsModalRef
  ) {}

  findADealer() {
    this.showLocateDealer.emit(true);
  }

  hideDirections() {
    this.displayMode = 'dealerInfo';
  }

  showDirections($event: string) {
    this.displayMode = $event;
  }
}
